export default class ParentSender {
  constructor() {
    this.parentOrigin = '*';
  }

  send(data) {
    window.parent.postMessage(
      { from: 'dealsWidget', ...data },
      this.parentOrigin
    );
  }

  ready() {
    return Promise.resolve(true);
  }
}
